module.exports = __webpack_public_path__ + "img/horizontal_6_2_9005.b14fe02f.png";